import BadgeCount from '../../../../shared/Badges/BadgeCount'
import Button from '../../../../shared/Buttons/Button'
import PlusIcon from '../../../../assets/icons/plus.svg?react'
import { useState } from 'react'
import CreateBlankSidePage from './components/CreateMaintenanceProcessSidePage'
import maintenanceProcessesAtom from './maintenanceProcesses.atom.ts'
import { useRecoilValue } from 'recoil'
import MaintenanceProcessesTable from './components/MaintenanceProcessesTable'
import ProtectedContent from '@/services/rights/ProtectedContent'

const MaintenanceProcesses = () => {
  const [createPageOpen, setCreatePageOpen] = useState(false)
  const processes = useRecoilValue(maintenanceProcessesAtom).items

  return (
    <>
      <div className="inline-flex-gap gap24 center">
        <div className="inline-flex-gap gap8 center">
          <h2 className="text-heading-4">Модели ТО</h2>
          <BadgeCount type="default" count={processes.length} />
        </div>
        <ProtectedContent
          requiredRight="mdm:create_schema"
          fallBack={
            <span className="text-nm text-description">
              Для добавления нового процесса обратитесь к администратору системы
            </span>
          }
        >
          <Button
            size="default"
            type="primary"
            text="Создать модель"
            icon={<PlusIcon className="text-white" />}
            onClick={() => setCreatePageOpen(true)}
          />
        </ProtectedContent>
      </div>
      <MaintenanceProcessesTable />
      <CreateBlankSidePage onClose={() => setCreatePageOpen(false)} open={createPageOpen} />
    </>
  )
}

export default MaintenanceProcesses
